/**
 * @license
 * Copyright (c) 2021 - 2026 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { button } from './button-base-styles.js';
import { field } from './field-base-styles.js';

export const inputFieldShared = [field, button];
